<template>
  <div class="carrot">
    <div class="deemed" v-if="visible"></div>
    <div class="layer-pop" v-if="visible">
      <div class="layer-pop-wrap">
        <h2 class="txt-right"><img src="@/assets/img/layer-close.svg" alt="닫기" @click="close()" /></h2>
        <div class="coach-youtube">
          <h3>
            {{ youtube.contentTitle }}
          </h3>
          <h4>{{ $date(youtube.contentCreatedDatetime).format("YYYY-MM-DD") }}</h4>
          <div v-if="isVideoLoading">
            <iframe
              :src="videoUrl"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <p>
            {{ youtube.contentReasonsRecommendation }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "surveyPop",
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false,
    },
    youtube: {
      type: Object,
      default: () => {
        return {
          thum: "",
        };
      },
    },
  },
  watch: {
    visible: function (newVal) {
      if (newVal == true) {
        this.visible = true;
        this.setVideoUrl();
      } else {
        this.visible = false;
      }
    },
  },
  data: () => ({
    videoUrl: "",
    isVideoLoading: false,
  }),
  mounted() {},
  methods: {
    setVideoUrl() {
      let replaceUrl = this.youtube.contentVideoUrl;
      let finUrl = "";
      replaceUrl = replaceUrl.replace("https://m.youtube.com/watch?v=", "");
      replaceUrl = replaceUrl.replace("https://youtu.be/", "");
      replaceUrl = replaceUrl.replace("https://www.youtube.com/embed/", "");
      replaceUrl = replaceUrl.replace("https://www.youtube.com/watch?v=", "");
      finUrl = replaceUrl.split("&")[0];
      this.videoUrl = `https://www.youtube.com/embed/${finUrl}`;
      this.isVideoLoading = true;
    },
    close() {
      this.$emit("close", false);
    },
  },
};
</script>
